import { useCallback } from 'react';
import { useLocation } from 'wouter';
import { useFirstStore } from '@/shared/contexts/first-store.context';

export function useHomeNavigation() {
  const [, navigate] = useLocation();
  const { getHomeUrl } = useFirstStore();

  const handleGoToHome = useCallback(() => {
    const homeUrl = getHomeUrl();
    console.log('🏠 Navegando para home:', homeUrl);
    navigate(homeUrl);
  }, [navigate, getHomeUrl]);

  return { handleGoToHome };
}
